import { render, staticRenderFns } from "./trainBaseList.vue?vue&type=template&id=49c6093c&scoped=true"
import script from "./trainBaseList.vue?vue&type=script&lang=js"
export * from "./trainBaseList.vue?vue&type=script&lang=js"
import style0 from "./trainBaseList.vue?vue&type=style&index=0&id=49c6093c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c6093c",
  null
  
)

export default component.exports